import { useEffect } from 'react';
import { useConfiguratorContext } from '@/kenwood/configurator/context';
import clearCart from '@/api/get/configuratorClearCart';

const useClearCart = () => {
  const [, { setCartEntries, setCartData }] = useConfiguratorContext();

  useEffect(() => {
    clearCart({
      successCB: () => {
        setCartEntries([]);
        setCartData(null);
      },
    });
  }, []);
};

export default useClearCart;
